var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckmarkCopy6 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 13,
  viewBox: "0 0 14 13",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#16E3B3",
  fillRule: "evenodd",
  d: "M.433 6.996 4.4 12.62c.348.493.93.506 1.299.033 0 0 7.211-9.28 7.868-10.004 1.313-1.448-.657-3.62-1.97-2.172C10.94 1.202 5.03 7.99 5.03 7.99S3.06 5.547 2.403 4.823C1.09 3.375-.88 5.547.433 6.996"
})));
export default SvgCheckmarkCopy6;